import React from 'react';
import PropTypes from 'prop-types';
import ChartCard from '../../ui/ChartCard';
import { Box, Typography } from '@mui/material';
import {
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
} from 'recharts';

const COLORS = ['#4e73df', '#1cc88a', '#36b9cc', '#f6c23e', '#e74a3b'];

// Función para truncar nombres largos
const truncateName = (name, maxLength = 20) => {
  if (!name) return 'Sin nombre';
  return name.length > maxLength ? `${name.substring(0, maxLength)}...` : name;
};

function CurrencyTooltipFormatter(value, name, props) {
  // Usar el nombre original si está disponible
  const displayName = props?.payload?.originalName || name;
  return [
    new Intl.NumberFormat('es-AR', {
      style: 'currency',
      currency: 'ARS',
      maximumFractionDigits: 0,
    }).format(value),
    displayName,
  ];
}

const TopProductsChartCard = ({ title = 'Productos más vendidos', data = [] }) => {
  const hasData = Array.isArray(data) && data.length > 0;
  
  // Procesar datos para truncar nombres largos
  const processedData = hasData ? data.map(item => ({
    ...item,
    name: truncateName(item.name),
    originalName: item.name // Mantener nombre original para tooltip
  })) : [];

  return (
    <ChartCard title={title} actionPath="/products" actionLabel="Ver todos">
      {hasData ? (
        <Box sx={{ height: 280 }}>
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={processedData}
                cx="50%"
                cy="50%"
                innerRadius={60}
                outerRadius={90}
                paddingAngle={5}
                dataKey="value"
                nameKey="name"
                label={({ percent }) => `${(percent * 100).toFixed(0)}%`}
              >
                {processedData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip formatter={CurrencyTooltipFormatter} />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        </Box>
      ) : (
        <Box
          sx={{
            height: 280,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'text.secondary',
          }}
        >
          <i className="bi bi-box-seam" style={{ fontSize: '2rem', opacity: 0.5 }}></i>
          <Typography variant="body2" sx={{ mt: 1 }}>
            No hay datos de productos
          </Typography>
        </Box>
      )}
    </ChartCard>
  );
};

TopProductsChartCard.propTypes = {
  title: PropTypes.string,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
    })
  ),
};

export default TopProductsChartCard;
